import type { LinkProps } from "@tanstack/react-router"
import type { FC } from "react"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

interface FinancialReportingTab {
  id: string
  label: string
  // Typed against the generated route tree so a tab pointing at a route that doesn't exist is a compile error instead of a 404 at runtime.
  path: NonNullable<LinkProps["to"]>
}

// AK-7071 AC1: The AP Aging Report is the first report available under Financial Reporting.
const FINANCIAL_REPORTING_TABS: FinancialReportingTab[] = [
  { id: "ap-aging-report", label: "AP Aging Report", path: "/app/financial-reporting/ap-aging-report" },
]

export const FinancialReportingLayout: FC = () => (
  <TabsLayout title='Financial Reporting' tabs={FINANCIAL_REPORTING_TABS} />
)
